import { render, staticRenderFns } from "./setChooseTextByVoice.vue?vue&type=template&id=35724666&scoped=true"
import script from "./setChooseTextByVoice.vue?vue&type=script&lang=js"
export * from "./setChooseTextByVoice.vue?vue&type=script&lang=js"
import style0 from "./setChooseTextByVoice.vue?vue&type=style&index=0&id=35724666&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35724666",
  null
  
)

export default component.exports